import { Checkbox } from 'ui/checkbox';

import { getUserDisplayName } from 'helpers/string.helpers';

import type { InsightUser } from 'components/partials/insight-modal/components/user-access-step/hooks/use-user-access';

interface CellContext {
  row: { original: InsightUser };
}

interface GetInsightUsersTableSettingsArgs {
  onUserChange: (changedUser: InsightUser) => void;
  onSelectAllUsers: (change: { hasAccess: boolean }) => void;
  isAllUsersSelected: boolean;
  isIndeterminate: boolean;
}

export const getInsightUsersTableSettings = ({
  onUserChange,
  onSelectAllUsers,
  isAllUsersSelected,
  isIndeterminate,
}: GetInsightUsersTableSettingsArgs) => [
  {
    id: 'button-cell',
    header: () => (
      <Checkbox
        id="selectAllInsightUsers"
        value="allSelected"
        checked={isAllUsersSelected}
        indeterminate={isIndeterminate}
        onChange={(_event, isChecked) =>
          onSelectAllUsers({ hasAccess: isChecked })
        }
        size="small"
        aria-label="Select all users"
        data-testid="checkbox-selectAllInsightUsers"
      />
    ),
    cell: ({
      row: {
        original: { email, firstName, hasAccess, lastName, userId },
      },
    }: CellContext) => (
      <Checkbox
        id={`userForInsight-${userId}`}
        value={String(userId)}
        checked={hasAccess}
        onChange={(_event, isChecked) =>
          onUserChange({ userId: String(userId), hasAccess: isChecked })
        }
        size="small"
        aria-label={`Insight access for ${getUserDisplayName({
          firstName,
          lastName,
          email,
          id: userId,
        })}`}
        data-testid={`checkbox-userForInsight-${userId}`}
      />
    ),
    headerClassName: 'h-12 rounded-tl-md rounded-bl-md border-r-2 border-white',
    className: 'pl-4 py-3 w-[3%]',
    enableSorting: false,
  },
  {
    id: 'name',
    accessorKey: 'firstName',
    header: () => (
      <span className="text-xs font-semibold text-navy-500">USER NAME</span>
    ),
    cell: ({
      row: {
        original: { firstName, lastName },
      },
    }: CellContext) => (
      <span className="font-semibold text-gray-700">{`${firstName} ${lastName}`}</span>
    ),
    headerClassName: 'border-r-2 border-white pl-4 h-12',
    className: 'pl-4 py-3 w-[20%]',
    enableSorting: false,
  },
  {
    id: 'jobTitle',
    accessorKey: 'jobTitle',
    header: () => (
      <span className="text-xs font-semibold text-navy-500">JOB TITLE</span>
    ),
    cell: ({
      row: {
        original: { jobTitle },
      },
    }: CellContext) => <span className="text-gray-700">{jobTitle}</span>,
    headerClassName: 'h-12 text-left rounded-tr-md rounded-br-md',
    className: 'pl-4 py-3 text-left w-[40%]',
    enableSorting: false,
  },
];
